function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Button from '../Button';
import Checkbox from '../Checkbox';
import nodeShape from './nodeShapeWithChildren';

var TreeNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  var _super = _createSuper(TreeNode);

  function TreeNode() {
    var _this;

    _classCallCheck(this, TreeNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onCheck", function () {
      var _this$props = _this.props,
          checked = _this$props.checked,
          onCheck = _this$props.onCheck,
          rawChildren = _this$props.rawChildren,
          value = _this$props.value;
      var isChecked = false; // Toggle off state to checked

      if (checked === 0) {
        isChecked = true;
      }

      onCheck({
        value: value,
        checked: isChecked,
        children: rawChildren
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onExpand", function () {
      var _this$props2 = _this.props,
          expanded = _this$props2.expanded,
          onExpand = _this$props2.onExpand,
          value = _this$props2.value;
      onExpand({
        value: value,
        expanded: !expanded
      });
    });

    return _this;
  }

  _createClass(TreeNode, [{
    key: "hasChildren",
    value: function hasChildren() {
      var rawChildren = this.props.rawChildren;
      return rawChildren !== null;
    }
  }, {
    key: "renderCollapseButton",
    value: function renderCollapseButton() {
      var _this$props3 = this.props,
          expandDisabled = _this$props3.expandDisabled,
          expanded = _this$props3.expanded,
          label = _this$props3.label;

      if (!this.hasChildren()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "accordion__label display-flex flex-row align-items-center",
          style: {
            marginLeft: 20
          }
        });
      }

      return /*#__PURE__*/React.createElement(Button, {
        size: "small",
        kind: "borderless",
        icon: "only",
        iconName: expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right',
        disabled: expandDisabled,
        className: "accordion__collapsed-btn",
        "aria-label": label,
        "aria-labelledby": label,
        "aria-expanded": expanded,
        type: "button",
        onClick: this.onExpand
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          expanded = _this$props4.expanded;

      if (!expanded) {
        return null;
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          checked = _this$props5.checked,
          children = _this$props5.children,
          className = _this$props5.className,
          content = _this$props5.content,
          disabled = _this$props5.disabled,
          expanded = _this$props5.expanded,
          label = _this$props5.label,
          accordionId = _this$props5.accordionId,
          value = _this$props5.value,
          level = _this$props5.level;
      var inputId = "".concat(accordionId, "-").concat(value.split(' ').join('_'));
      var nodeClass = classNames({
        accordion: true,
        list: true,
        'accordion--disabled': disabled
      }, className);
      return /*#__PURE__*/React.createElement("li", {
        className: nodeClass,
        "aria-label": label,
        role: "treeitem",
        "aria-selected": checked,
        "aria-describedby": checked,
        "aria-expanded": expanded,
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("div", {
        htmlFor: inputId,
        className: checked ? 'accordion__element--selected display-flex flex-row align-items-center' : 'accordion__element display-flex flex-row align-items-center'
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: checked,
        disabled: disabled,
        id: inputId,
        value: "",
        name: label,
        onChange: this.onCheck,
        className: "accordion__checkbox",
        "aria-label": checked === 1 && children ? "".concat(label, " Level ").concat(level + 1, " This selects the parent and all subchildren") : "".concat(label, " Level ").concat(level + 1),
        "aria-describedby": checked === 1 && children ? 'This selects the parent and all subchildren' : ''
      }), /*#__PURE__*/React.createElement("div", {
        className: "accordion__label display-flex flex-row align-items-center",
        style: {
          marginLeft: level * 20 || null
        }
      }, this.renderCollapseButton(), /*#__PURE__*/React.createElement("div", {
        className: "accordion__labelName",
        "aria-label": label,
        role: "presentation"
      }, label), content && /*#__PURE__*/React.createElement(this.props.content, this.props))), /*#__PURE__*/React.createElement("ul", null, this.renderChildren()));
    }
  }]);

  return TreeNode;
}(React.Component);

_defineProperty(TreeNode, "propTypes", {
  checked: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  expandDisabled: PropTypes.bool.isRequired,
  expanded: PropTypes.bool,
  label: PropTypes.node.isRequired,
  accordionId: PropTypes.string,
  value: PropTypes.string.isRequired,
  onCheck: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  rawChildren: PropTypes.arrayOf(nodeShape),
  optimisticToggle: PropTypes.bool,
  content: PropTypes.func,
  level: PropTypes.number
});

_defineProperty(TreeNode, "defaultProps", {
  children: null,
  className: null,
  rawChildren: null
});

TreeNode.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onCheck",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onExpand",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "hasChildren",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderCollapseButton",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderChildren",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "TreeNode",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "rawChildren": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "nodeShape"
        }
      },
      "required": false,
      "description": ""
    },
    "checked": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": true,
      "description": ""
    },
    "expandDisabled": {
      "type": {
        "name": "bool"
      },
      "required": true,
      "description": ""
    },
    "expanded": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "accordionId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "onCheck": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "onExpand": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "optimisticToggle": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "content": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "level": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TreeNode;